module.exports = __webpack_public_path__ + "static/media/Noura Kids.ea11b886.jpeg";